import { render } from "./footer.vue?vue&type=template&id=0a823c22&ts=true"
import script from "./footer.component.ts?vue&type=script&lang=ts"
export * from "./footer.component.ts?vue&type=script&lang=ts"

import exportComponent from "/Volumes/ExDisk/Cong viec/LuvTransitltms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__